import { $, owlCarousel } from "./imports";

const certificatesCarousel = () => {
    if($('.block-certificates .block-certificates__list .block-certificates__item').length > 1){
        let $certificatesCarouselAbout = $('.block-certificates .block-certificates__list').addClass('owl-carousel').owlCarousel({
            nav: false,
            dots: false,
            margin: 25,
            navText: [
                '<svg xmlns="http://www.w3.org/2000/svg" width="8.551" height="13.847" viewBox="0 0 8.551 13.847"><path d="M15.514,6l1.627,1.627-5.285,5.3,5.285,5.3-1.627,1.627L8.59,12.923Z" transform="translate(-8.59 -6)" fill="#3c271a"/></svg>',
                '<svg xmlns="http://www.w3.org/2000/svg" width="8.551" height="13.847" viewBox="0 0 8.551 13.847"><path d="M10.217,6,8.59,7.627l5.285,5.3L8.59,18.22l1.627,1.627,6.923-6.923Z" transform="translate(-8.59 -6)" fill="#3c271a"/></svg>'
            ],
            loop: true,
            items: 1,
            autoplay: true,
            autoplayTimeout: 8000,
            autoplayHoverPause: true,
            autoWidth: true,
            center: true,
            responsive: {
                0:{
                    nav: false,
                    dots: true,
                    items: 2,
                    margin: 25,
                    stagePadding: 100,
                },
                768: {
                    nav: false,
                    dots: true,
                    items: 3,
                    margin: 25,
                    stagePadding: 100,
                },
                992: {
                    nav: false,
                    dots: false,
                    items: 4,
                    margin: 45,
                    stagePadding: 100,
                },
                1200: {
                    nav: false,
                    dots: false,
                    items: 5,
                    margin: 65,
                    stagePadding: 100,
                },
                1400: {
                    nav: false,
                    dots: false,
                    items: 5,
                    margin: 85,
                    stagePadding: 150,
                }
            }
        });
    }
}

export default certificatesCarousel;